<template>
  <div>
    <ts-card>
      <div
        class="form-header ts-bg-gray-100 ts-border-b ts-border-gray-400 ts-p-4 ts-relative"
      >
        <h4 class="ts-text-sm">{{ $t('restaurantSale.moveTable') }}</h4>
      </div>
    </ts-card>
    <form>
      <ts-card-wrapper>
        <div class="row">
          <div class="col-lg-6">
            <div class="form-group">
              <label class="col-form-label control-label required">{{
                $t('restaurantSale.fromTable')
              }}</label>
              <div>
                <treeselect
                  :options="
                    fromTables.map(el => ({
                      stock_out_id: el.stock_out_id,
                      id: el.table_id,
                      label:
                        'Table: ' + el.table_no + ' | Order: #' + el.order_no
                    }))
                  "
                  @select="value => (model.stock_out_id = value.stock_out_id)"
                  :placeholder="$t('select')"
                  v-model="model.table_from_id"
                  @input="model.table_to_id = null"
                  :maxHeight="150"
                />
              </div>
            </div>
          </div>
          <div class="col-lg-6">
            <div class="form-group">
              <label class="col-form-label control-label required">{{
                $t('restaurantSale.toTable')
              }}</label>
              <div>
                <treeselect
                  :options="
                    toTables.map(el => ({
                      id: el.table_id,
                      label: 'Table: ' + el.table_no
                    }))
                  "
                  :placeholder="$t('select')"
                  v-model="model.table_to_id"
                  :disabled="!model.table_from_id ? true : false"
                  :maxHeight="150"
                />
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-lg-12">
            <div class="form-group">
              <label class="col-form-label control-label required">{{
                $t('restaurantSale.reason')
              }}</label>
              <div>
                <textarea
                  v-model="model.reason"
                  rows="2"
                  class="form-control"
                ></textarea>
              </div>
            </div>
          </div>
        </div>
      </ts-card-wrapper>
      <div class="btn-row">
        <ts-button
          type="submit"
          color="info"
          class="btn-block"
          @click.prevent="move"
          :disabled="model.table_to_id ? false : true"
          :waiting="waiting"
          ><i class="fas fa-arrow-circle-right"></i>
          {{ $t('restaurantSale.move') }}</ts-button
        >
      </div>
    </form>
  </div>
</template>

<script>
import { Errors } from 'form-backend-validation'

export default {
  name: 'moveTable',
  data () {
    return {
      model: {
        stock_out_id: null,
        table_from_id: null,
        table_to_id: null,
        reason: null
      },
      waiting: false,
      errors: new Errors()
    }
  },
  created () {
    this.model.table_from_id = this.tableSelected.table_id
    this.model.stock_out_id = this.tableSelected.stock_out_id
  },
  computed: {
    tableSelected () {
      return this.$store.state.restaurantSale.counterCheckout.tableSelected
    },
    fromTables () {
      return _.sortBy(
        this.$store.state.restaurantSale.counterCheckout.tables.filter(
          t => t.status_id == 3
        ),
        ['display_order']
      )
    },
    toTables () {
      return _.sortBy(
        this.$store.state.restaurantSale.counterCheckout.tables.filter(
          t => t.status_id == 1 && t.table_id != this.model.table_from_id
        ),
        ['display_order']
      )
    }
  },
  methods: {
    async move () {
      this.waiting = true
      await this.$store
        .dispatch('restaurantSale/counterCheckout/moveTable', this.model)
        .then(response => {
          this.$toasted.success(response.messages)
          this.$store
            .dispatch('restaurantSale/counterCheckout/fetchTables')
            .then(() => {
              this.$store.commit(
                'restaurantSale/counterCheckout/RECEIVE_TABLE_SELECTED',
                this.$store.state.restaurantSale.counterCheckout.tables
                  .filter(t => t.table_id == this.model.table_to_id)
                  .reduce((init, value) => (init = value), {})
              )
            })
          this.$emit('before-close')
          this.$emit('close')
        })
        .catch(error => {
          this.$toasted.error(error.messages)
        })
        .finally(() => {
          this.waiting = false
        })
    }
  }
}
</script>
<style scoped>
.btn-row .btn {
  padding: 15px 20px;
  font-size: 0.875rem;
  min-width: 100px;
  text-align: center;
  position: relative;
  border-radius: 0;
}
</style>
